import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { CdkDrag } from '@angular/cdk/drag-drop';
import { EmailPreview } from 'src/app/admin/logged-time/notification-management/models/email-preview';

@Component({
  selector: 'app-email-preview-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
    TranslateModule,
    CdkDrag,
  ],
  templateUrl: './email-preview-dialog.component.html',
  styleUrl: './email-preview-dialog.component.scss',
})
export class EmailPreviewDialogComponent {
  private readonly sanitizer = inject(DomSanitizer);
  data = inject<EmailPreview>(MAT_DIALOG_DATA);
  readonly sanitizedBody = this.sanitizer.bypassSecurityTrustHtml(this.data.body);
}
